import React from 'react';
import Imgix from "react-imgix";
import {getEpochFromDate, getSocialIconByDomainName} from "../../common/services/logic-provider";
import {AVATAR_PATH} from "../../common/constants";
import VerifiedIcon from "../../../../ui/svg/common/verified";
import {isMobile} from "../../../../domain/common";
import {ProfileDM, SiteDM} from "../../common/interfaces";


export interface ICreatorDetailsProps {
    profile: ProfileDM;
    sites?:SiteDM[];
    imgCdnDomain:string;
    creatorsPath:string;
    showBio?:boolean;
    cancelImgLazyload?:boolean;
}
const CreatorDetails = (props : ICreatorDetailsProps) => {


    const isMobileScreen = isMobile();

    return (
        <div className="w-full bg-white" style={isMobileScreen ? {top:"114.03px"}:{top:"88.52px"}}>
            <div className="flex py-6">
                <div className="">
                        <div className="w-20 h-20 mr-4">
                            {props.profile.imgExt.length > 0 ?
                                <Imgix
                                    src= {props.imgCdnDomain + "/" +
                                          props.creatorsPath +
                                        props.profile.prfUserGUID + "."  +
                                        props.profile.imgExt  + "?epoch=" + getEpochFromDate(props.profile.itemModifiedWhen)}
                                    sizes={"auto"}
                                    width={200}
                                    height={200}
                                    imgixParams={{ mask:"ellipse" }}
                                    htmlAttributes={{
                                        alt: `${props.profile.handle} profile image`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}

                                />
                                :
                                <Imgix
                                    src= {props.imgCdnDomain + AVATAR_PATH}
                                    sizes={"auto"}
                                    width={200}
                                    height={200}
                                    imgixParams={{ fit: "facearea",facepad:"1.9",mask:"ellipse" }}
                                    htmlAttributes={{
                                        alt: `${props.profile.handle} profile image`,
                                        loading: props.cancelImgLazyload ? undefined : 'lazy',
                                    }}
                                />
                            }
                        </div>

                </div>
                <div className="flex-1 h-max overflow-hidden">
                    <div className="w-full flex items-center h-min relative">
                        <div className="flex-1">
                            <div className="w-full text-2xl font-bold">
                                <div className="flex items-center">
                                    <h1 className="w-ellipsis">{props.profile.publicName}</h1>
                                    {props.profile.isVerified &&
                                        <div className="ml-2">
                                            <VerifiedIcon width="20px" />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="w-full text-sm">
                        <a className="text-black" href={"/studioverse/creator/" + props.profile.handle.toLowerCase()}>
                        @{props.profile.handle}
                        </a>
                        {props.profile.isUserOwner ?
                            <span>
                                <span className="px-4">|</span>
                                <a href={"/account/edit-my-creator-profile"}>Edit Profile</a>
                            </span>
                            :<></>
                        }
                    </div>

                    <div className="flex items-center justify-start mt-4 md:mt-2 text-sm">

                        {props.sites !== undefined && props.sites.length > 0 &&
                            <div className="mr-2 font-bold">Follow</div>
                        }
                        {props.sites !== undefined && props.sites.map((site,index) => {
                            return  <a key={index} className="mx-4 xl:mx-2 cursor-pointer" href={site.siteURL} rel="noreferrer" target={"_blank"}>{getSocialIconByDomainName(site.domainName,"18px")}</a>
                        })}
                    </div>

                </div>
            </div>
            {props.showBio ?
                <div className="w-full">{props.profile.bio}</div>:<></>
            }
        </div>

    )
};

export default CreatorDetails;